import { render, staticRenderFns } from "./StorageQuestionsTab.vue?vue&type=template&id=4f2baf9f&scoped=true&"
import script from "./StorageQuestionsTab.vue?vue&type=script&lang=js&"
export * from "./StorageQuestionsTab.vue?vue&type=script&lang=js&"
import style0 from "./StorageQuestionsTab.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./StorageQuestionsTab.vue?vue&type=style&index=1&id=4f2baf9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2baf9f",
  null
  
)

export default component.exports